angular.module('qkr').factory('machinesServices', ($http, appConfig,  utils, APP_CONSTANT) => {
    const response = function(r) {
        return r;
    };

    function formatCommand(form) {
        /**
         * Convert form values into server-friendly format
         */
        const command = utils.withoutProperties(form, []);
        
        return command;
    }

    return {
        loadList() {
            const payload = {
                withCredentials: true,

                // Required to prevent null command error
                params: {
                    radius: 0
                }
            };
            return $http.get(appConfig.apiUrl + 'vending/listMachines', payload).then(response);
        },
        create(form) {
            const command = formatCommand(form);
            return $http.post(appConfig.apiUrl + 'vending/createMachine', command).then(response);
        },
        update(form) {
            const command = formatCommand(form);
            return $http.post(appConfig.apiUrl + 'vending/updateMachine', command).then(response);
        },

        deleteMachine(machine) {
            return $http.post(appConfig.apiUrl + 'vending/deleteMachine', {value: machine.machineRefId || 0})
                .then((response) => response.data);
        },
	    getDiscountLabel(machine) {
	        if (!machine)
	            return '-';

		    /** @namespace machine.discountType */
		    /** @namespace machine.discountValue */
		    if (machine.discountType === APP_CONSTANT.DiscountType.DISCOUNT_PERCENT) {
			    return machine.discountValue + '%';
		    }

		    if (machine.discountType === APP_CONSTANT.DiscountType.DISCOUNT_AMOUNT) {
			    return machine.discountValue + 'cnt';
		    }

		    return '-';
	    }
    };
});



// WEBPACK FOOTER //
// ./src/services/machines.service.js